/* Lumera cart extras: upsell "Add" buttons + Shipping Protection checkbox.
   Loaded globally (never inside the drawer markup) because the cart drawer is
   re-rendered through the Section Rendering API and scripts injected that way
   never execute. All handlers are delegated on document, so they keep working
   no matter how many times the drawer re-renders. */
(function () {
  /* __lmCartExtras is the flag of the older in-drawer script. Checking both ways
     means exactly one set of handlers is ever bound, whichever runs first. */
  if (window.__orthoCart || window.__lmCartExtras) return;
  window.__orthoCart = true;
  window.__lmCartExtras = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function url(path) {
    return root.replace(/\/$/, '') + path;
  }

  function post(path, body) {
    return fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
  }

  var EventsPromise = null;
  function events() {
    if (!EventsPromise) {
      EventsPromise = import('@theme/events').catch(function () {
        return null;
      });
    }
    return EventsPromise;
  }

  /* Tell the theme the cart changed so the drawer, header count and the
     free-shipping bar all re-render. */
  function refresh(variantId) {
    return fetch(url('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        return events().then(function (mod) {
          var detail = { source: 'ortho-cart', itemCount: cart.item_count, variantId: variantId };
          if (mod && mod.CartAddEvent) {
            document.dispatchEvent(new mod.CartAddEvent(cart, 'ortho-cart', detail));
          } else {
            document.dispatchEvent(
              new CustomEvent('cart:add', {
                bubbles: true,
                detail: { resource: cart, sourceId: 'ortho-cart', data: detail },
              })
            );
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: { resource: cart, sourceId: 'ortho-cart', data: detail },
              })
            );
          }
          return cart;
        });
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lm-add]');
    if (!btn) return;
    e.preventDefault();

    var row = btn.closest('.oce-up__item');
    var sel = row ? row.querySelector('.oce-up__size') : null;
    var variantId = sel && sel.value ? sel.value : btn.getAttribute('data-lm-add');

    if (!variantId) {
      if (sel) {
        sel.classList.add('oce-up__size--need');
        sel.focus();
      }
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Adding';
    if (row) row.classList.add('oce-up__item--go');

    post('/cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return refresh(variantId).then(function () {
          /* The drawer re-renders itself; the cart page's list does not, so the
             row that was just added is taken out by hand. */
          if (row && row.isConnected) setTimeout(function () { row.remove(); }, 400);
        });
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add';
        if (row) row.classList.remove('oce-up__item--go');
      });
  });

  document.addEventListener('change', function (e) {
    var size = e.target.closest && e.target.closest('.oce-up__size');
    if (size) size.classList.remove('oce-up__size--need');

    var box = e.target.closest && e.target.closest('[data-lm-prot]');
    if (!box) return;

    box.disabled = true;
    var id = box.getAttribute('data-lm-prot');
    var add = box.checked;

    var req = add
      ? post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
      : post('/cart/update.js', { updates: JSON.parse('{"' + id + '":0}') });

    req
      .then(function (res) {
        if (!res.ok) throw new Error('protection failed');
        return refresh(id);
      })
      .catch(function () {
        box.checked = !add;
        box.disabled = false;
      });
  });
})();
